import { useDevice, computed } from '#imports'
import { useMediaQuery, createSharedComposable } from '@vueuse/core'

export const usePlaygameView = createSharedComposable(() => {
    const { isMobile, isTablet } = useDevice()

    // useMediaQuery returns false during SSR → tablets default to mobile view (portrait-first)
    const isLandscape = useMediaQuery('(orientation: landscape)')

    const isMobileView = computed<boolean>(() => {
        if (isMobile) return true
        if (isTablet) return !isLandscape.value
        return false
    })

    const isDesktopView = computed<boolean>(() => !isMobileView.value)

    const view = computed<'desktop' | 'mobile'>(() =>
        isMobileView.value ? 'mobile' : 'desktop'
    )

    const isTabletPortrait = computed<boolean>(() => isTablet && !isLandscape.value)

    return { isMobileView, isDesktopView, view, isTablet, isMobile, isTabletPortrait }
})
